import { render, staticRenderFns } from "./SmartPromptsPanel.vue?vue&type=template&id=f62436fc&scoped=true"
import script from "./SmartPromptsPanel.vue?vue&type=script&lang=js"
export * from "./SmartPromptsPanel.vue?vue&type=script&lang=js"
import style0 from "./SmartPromptsPanel.vue?vue&type=style&index=0&id=f62436fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.43_css-loader@6.11.0_webpack@5.111.1_postcss@8_cee907f41370107bcc48efa63f51a283/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62436fc",
  null
  
)

export default component.exports